module.exports = __webpack_public_path__ + "img/Tamaraw-Society.6b4fed26.png";